<template>
  <div class="container">
    <customer-new @submit="customerCreated" ref="customerNew"></customer-new>
    <!-- HEADER -->
    <div class="row mb-3">
      <div class="col-sm-6">
        <h1 class="page-title">LISTA DE PACIENTES</h1>
      </div>
      <div class="col-sm-2 text-center">
        <button @click="addNewCustomer" type="button" class="btn btn-wabident-round btn-block">
          <i class="fas fa-plus mr-1"></i>
          Nuevo paciente
        </button>
      </div>
      <div class="col-sm-2 text-center">
        <button @click="downloadCustomers" type="button" class="btn btn-wabident-round btn-block">
          <i class="fas fa-download mr-1"></i>
          Descargar
        </button>
      </div>
      <div class="col-sm-2 text-center">
        <button @click="downloadUnpaidCustomers" type="button" class="btn btn-wabident-round btn-block">
          <i class="fas fa-download mr-1"></i>
          Descuadres
        </button>
      </div>
    </div>
    <!-- SEARCH  INPUT-->
    <div class="row form-group">
      <div class="col-sm-3">
        <input v-model="name" class="form-control icon" type="search" name="name" id="customer_search_name" />
        <label class="wabident-info" for="customer_search_name">Nombre</label>
      </div>

      <div class="col-sm-3">
        <input v-model="surname" class="form-control icon" type="search" name="surname" id="customer_search_surname" />
        <label class="wabident-info" for="customer_search_surname">Apellidos</label>
      </div>

      <div class="col-sm-3">
        <input v-model="phone" class="form-control icon" type="search" name="phone" id="customer_search_phone" />
        <label class="wabident-info" for="customer_search_phone">Teléfono</label>
      </div>

      <div class="col-sm-3">
        <input v-model="nif" class="form-control icon" type="search" name="nif" id="customer_search_nif" />
        <label class="wabident-info" for="customer_search_nif">NIF</label>
      </div>
    </div>


    <div class="row form-group">
      <div class="col">
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="checkbox" id="advanced_search" v-model="advanced_search" />
          <label class="form-check-label" for="advanced_search">Búsqueda avanzada</label>
        </div>
      </div>
    </div>

    <div v-if="advanced_search" class="row form-group">
      <div class="col-sm-12">
        <h6>DATOS DE LA FICHA</h6>
      </div>

      <div class="col-sm-3">
        <input v-model="representative_search" type="text" class="form-control" id="representative_search" />
        <label class="wabident-info" for="invisalign_id_to">Representante: Nombre, DNI, etc ...</label>
      </div>

      <div v-if="enable_sepa_transfers" class="col-sm-3">
        <input v-model="sepa_search" type="text" class="form-control" id="sepa_search" />
        <label class="wabident-info" for="invisalign_id_to">Datos Bancarios: Nombre, DNI, IBAN, etc ..</label>
      </div>

      <div class="col-sm-3 mb-2">
        <doctor-selector v-model="doctor_id" id="doctor_id" label="Doctor/a de Referencia"
          placeholder="Elige"></doctor-selector>
      </div>

      <div class="col-sm-2">
        <select v-model="search_clinic" id="select_clinic" class="custom-select">
          <option :value="null">Todas</option>
          <option v-for="(name, index) in clinics" :key="index" :value="index">
            {{ name }}
          </option>
        </select>
        <label class="wabident-info" for="select_clinic">Clínica</label>
      </div>

      <div class="col-sm-2">
        <select v-model="is_consent_signed" id="select_data_signed" class="custom-select">
          <option :value="null">Todos</option>
          <option :value="1">Sí</option>
          <option :value="0">No</option>
        </select>
        <label class="wabident-info" for="select_data_signed">Protección Datos Firmado</label>
      </div>

      <div class="col-sm-1" v-if="has_invisalign_id">
        <input v-model="invisalign_id_from" type="text" class="form-control" id="invisalign_id_from" />
        <label class="wabident-info" for="invisalign_id_from">N. Historia Desde</label>
      </div>

      <div class="col-sm-1" v-if="has_invisalign_id">
        <input v-model="invisalign_id_to" type="text" class="form-control" id="invisalign_id_to" />
        <label class="wabident-info" for="invisalign_id_to">N. Historia Hasta</label>
      </div>
    </div>

    <div v-if="advanced_search" class="row form-group">
      <div class="col-sm-12">
        <h6>POR FECHAS</h6>
      </div>

      <div class="col-sm-2">
        <input v-model="date_from" type="date" class="form-control" id="select_date_from" />
        <label class="wabident-info" for="select_date_from">F.Nacimiento Desde</label>
      </div>

      <div class="col-sm-2">
        <input v-model="date_to" type="date" class="form-control" id="select_date_to" />
        <label class="wabident-info" for="select_date_to">F.Nacimiento Hasta</label>
      </div>

      <div class="col-sm-2">
        <input v-model="created_date_from" type="date" class="form-control" id="select_created_date_from" />
        <label class="wabident-info" for="select_created_date_from">F.Alta Desde</label>
      </div>

      <div class="col-sm-2">
        <input v-model="created_date_to" type="date" class="form-control" id="cselect_created_date_to" />
        <label class="wabident-info" for="select_created_date_to">F.Alta. Hasta</label>
      </div>

      <div class="col-sm-2">
        <input v-model="appointment_date_from" type="date" class="form-control" id="select_appointment_date_from" />
        <label class="wabident-info" for="select_appointment_date_from">F.Última Cita Desde</label>
      </div>

      <div class="col-sm-2">
        <input v-model="appointment_date_to" type="date" class="form-control" id="select_appointment_date_to" />
        <label class="wabident-info" for="select_appointment_date_to">F.Última Cita Hasta</label>
      </div>
    </div>

    <!-- RESULTS -->
    <div class="row">
      <div class="col-sm-12">
        <div v-show="is_searching" class="text-center">
          <h2 class="customer-search-empty-message my-4">
            Buscando &hellip;
            <i class="fas fa-spin fa-circle-notch"></i>
          </h2>
        </div>
        <div v-show="!has_results_available" class="text-center">
          <h2 class="customer-search-empty-message my-4">
            {{ empty_message }}
          </h2>
        </div>
        <div v-show="has_results_available" class="customer-search-wrapper">
          <table class="table customer-search-results">
            <thead>
              <tr>
                <th colspan="1" class="text-center">#ID</th>
                <th v-if="has_invisalign_id" colspan="1" class="text-center">#HIST</th>
                <th colspan="7">PACIENTE</th>
                <th colspan="2">TELÉFONO</th>
                <th colspan="2">CLÍNICA REF.</th>
                <th colspan="1">F. NAC</th>
                <th colspan="1">F. CREAC</th>
                <th v-if="is_core" colspan="1">ALTA DATOS</th>
              </tr>
            </thead>
            <tbody>
              <tr class="customer-search-results__row" v-for="(customer, index) in search_customers" :key="index"
                @click="customerClicked(customer)">
                <td colspan="1" class="text-center">
                  {{ customer.history_number }}
                </td>

                <td v-if="has_invisalign_id" colspan="1" class="text-center">
                  <span v-if="customer.custom_fields">
                    {{ customer.custom_fields.invisalign_id }}
                  </span>
                </td>

                <td colspan="7">
                  <div>
                    {{ customer.full_name }}
                    <span v-if="!customer.has_paid">
                      - <i class="fas fa-money-bill-alt"></i>
                    </span>
                    <span v-if="!customer.is_consent_signed">
                      - <i class="fas fa-edit"></i>
                    </span>
                  </div>

                  <small class="my-1 customer-search-detail"
                    v-if="is_rep_searched && customer.adult_name && customer.adult_name != ''">
                    <strong>{{ adult_types[customer.adult_type] }}</strong> : {{ customer.adult_name }}, {{
                      customer.adult_nif }},
                    {{ customer.adult_phone }}
                  </small>

                  <small class="my-1 customer-search-detail"
                    v-if="is_rep_searched && customer.adult2_name && customer.adult2_name != ''">
                    <strong>{{ adult_types[customer.adult2_type] }}</strong> : {{ customer.adult2_name }}, {{
                      customer.adult2_nif }},
                    {{ customer.adult2_phone }}
                  </small>

                  <small class="my-1 customer-search-detail" v-if="is_sepa_searched">
                    <div v-for="acc in customer.payment_info.sepa_accounts">
                      <strong>Cuenta</strong> {{ acc.name }} - {{ acc.iban }}
                    </div>
                  </small>

                </td>
                <td colspan="2">{{ customer.phone }}</td>
                <td colspan="2">{{ showClinic(customer) }}</td>
                <td colspan="1">
                  {{ customer.birth_date ? fmtDate(customer.birth_date) : "" }}
                </td>
                <td colspan="1">{{ fmtDate(customer.created_at) }}</td>
                <td v-if="is_core" colspan="1">
                  {{ customer.is_filled ? "Sí" : "No" }}
                </td>
              </tr>
              <tr></tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- Pagination -->
    <div v-if="has_results_available" class="row">
      <div class="col text-center customer-search-pagination my-2">
        <button :disabled="is_first_page" @click="goFirst" type="button"
          class="btn btn-primary btn-wabident-round mx-1">
          <i class="fas fa-angle-double-left"></i>
        </button>
        <button :disabled="is_first_page" @click="goPrev" type="button" class="btn btn-primary btn-wabident-round mx-1">
          <i class="fas fa-angle-left"></i>
        </button>
        <label class="customer-search-pagination-locator mx-2">
          Página
          {{ current_page }} de {{ total_pages }}
        </label>
        <button :disabled="is_last_page" @click="goNext" type="button" class="btn btn-primary btn-wabident-round mx-1">
          <i class="fas fa-angle-right"></i>
        </button>
        <button :disabled="is_last_page" @click="goLast" type="button" class="btn btn-primary btn-wabident-round mx-1">
          <i class="fas fa-angle-double-right"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      search: "",
      name: "",
      surname: "",
      nif: "",
      phone: "",
      search_results: [],
      search_clinic: null,
      date_from: null,
      date_to: null,
      created_date_from: null,
      created_date_to: null,
      appointment_date_from: null,
      appointment_date_to: null,
      is_consent_signed: null,
      page: 1,
      is_searching: false,
      selected_customer: null,
      advanced_search: null,
      doctor_id: null,
      invisalign_id_from: null,
      invisalign_id_to: null,
      representative_search: null,
      sepa_search: null,
    };
  },
  watch: {
    doctor_id(v) {
      this.page = 1;
      this.searchCustomers(this.search)
    },
    name(value) {
      this.page = 1;
      this.searchCustomers(this.search);
    },
    surname(value) {
      this.page = 1;
      this.searchCustomers(this.search);
    },
    phone(value) {
      this.page = 1;
      this.searchCustomers(this.search);
    },
    nif(value) {
      this.page = 1;
      this.searchCustomers(this.search);
    },
    search(value) {
      this.page = 1;
      this.searchCustomers(this.search);
    },
    search_clinic(v) {
      this.page = 1;
      this.searchCustomers(this.search);
    },
    date_from(v) {
      this.page = 1;
      this.searchCustomers(this.search);
    },
    date_to(v) {
      this.page = 1;
      this.searchCustomers(this.search);
    },
    created_date_from(v) {
      this.page = 1;
      this.searchCustomers(this.search);
    },
    created_date_to(v) {
      this.page = 1;
      this.searchCustomers(this.search);
    },
    appointment_date_from(v) {
      this.page = 1;
      this.searchCustomers(this.search);
    },
    appointment_date_to(v) {
      this.page = 1;
      this.searchCustomers(this.search);
    },
    is_consent_signed(v) {
      this.page = 1;
      this.searchCustomers(this.search);
    },
    invisalign_id_from(v) {
      this.page = 1;
      this.searchCustomers(this.search);
    },
    invisalign_id_to(v) {
      this.page = 1;
      this.searchCustomers(this.search);
    },
    representative_search(v) {
      this.page = 1;
      this.searchCustomers(this.search);
    },
    sepa_search(v) {
      this.page = 1;
      this.searchCustomers(this.search);
    },
  },
  props: {
    clinic_id: { required: true },
  },
  computed: {
    enable_sepa_transfers() {
      return this.clinic &&
        this.clinic.config &&
        this.clinic.config.payments_enable_sepa_transfers;
    },
    adult_types() {
      return WabiDent.AdultType;
    },
    is_rep_searched() {
      return this.representative_search && this.representative_search != '';
    },
    is_sepa_searched() {
      return this.sepa_search && this.sepa_search != '';
    },
    has_invisalign_id() {
      return this.clinic &&
        this.clinic.config &&
        this.clinic.config.customer_custom_fields_config &&
        this.clinic.config.customer_custom_fields_config.invisalign_id;
    },
    is_first_page() {
      if (!this.has_results_available) return true;
      return this.search_results.current_page == 1;
    },
    is_last_page() {
      if (!this.has_results_available) return true;
      return this.search_results.current_page == this.search_results.last_page;
    },
    search_customers() {
      if (this.is_searching) return [];
      if (!this.search_results.data) return [];
      return this.search_results.data;
    },
    current_page() {
      if (!this.has_results_available) return 0;
      return this.search_results.current_page;
    },
    total_pages() {
      if (!this.has_results_available) return 0;
      return this.search_results.last_page;
    },
    clinics() {
      if (!this.clinic) return [];
      return this.clinic.clinic_names || [];
    },
    has_results_available() {
      return (
        this.search_results &&
        this.search_results.data &&
        this.search_results.data.length != 0
      );
    },
    empty_message() {
      return "Lo siento, no pude encontrar ningún paciente con esos datos";
    },
    clinics() {
      if (!this.clinic) return [];
      return this.clinic.clinic_names;
    },
    ...mapGetters(["clinic", "is_core", "msgwindow"]),
  },
  methods: {
    customerCreated() {
      this.goFirst();
    },
    goFirst() {
      this.page = 1;
      this.searchCustomers(this.search);
    },
    goPrev() {
      this.page -= 1;
      this.searchCustomers(this.search);
    },
    goNext() {
      this.page += 1;
      this.searchCustomers(this.search);
    },
    goLast() {
      this.page = this.total_pages;
      this.searchCustomers(this.search);
    },
    showClinic(customer) {
      return this.clinics[customer.clinic_id] || "";
    },
    fmtDate(date) {
      let d = moment(date);
      return d.format("L");
    },
    addNewCustomer() {
      this.$refs.customerNew.show();
    },
    downloadCustomers() {
      const params = this.getSearchParams();
      let sparams = new URLSearchParams();
      for (const key in params) {
        let value = params[key];
        if (value != null && value != "") {
          sparams.append(key, value);
        }
      }

      this.msgwindow.info(
        "Generando listado. Tardará unos minutos. Por favor no cierre la pestaña ..."
      );
      window.location = `/customer/xls/?` + sparams.toString();
    },
    downloadUnpaidCustomers() {
      window.location = `/customer/unpaid`;
    },
    customerClicked(customer) {
      window.location = `/customer/${customer.id}/edit`;
    },
    getSearchParams() {
      let params = {
        search: this.search,
        name: this.name,
        surname: this.surname,
        nif: this.nif,
        phone: this.phone,
        paged: true,
        page: this.page,
        clinic_id: this.search_clinic,
        doctor_id: this.doctor_id,
        date_from: this.date_from,
        date_to: this.date_to,
        created_date_from: this.created_date_from,
        created_date_to: this.created_date_to,
        appointment_date_from: this.appointment_date_from,
        appointment_date_to: this.appointment_date_to,
        is_consent_signed: this.is_consent_signed,
        representative_search: this.representative_search,
        sepa_search: this.sepa_search,
      };

      if (this.has_invisalign_id) {
        params.invisalign_id_from = this.invisalign_id_from;
        params.invisalign_id_to = this.invisalign_id_to;
      }

      return params;
    },
    searchCustomers(search, page = 1) {
      if (this.is_searching) return;
      this.is_searching = true;
      axios
        .get("/customer/search", {
          params: this.getSearchParams(),
        })
        .then((response) => {
          this.search_results = response.data;
        })
        .catch((error) => {
          console.log("[ERR] searchCustomers:", error);
        })
        .then(() => {
          this.is_searching = false;
        });
    },
    loadClinicData() {
      if (!this.clinic) {
        axios
          .get("/agenda/clinic_info", {
            params: {
              clinic_id: this.clinic_id,
            },
          })
          .then((response) => {
            let data = response.data;
            if (data.error) {
              console.log("[ERR] loadClinicData:", data.error);
            } else {
              this.setClinic(data);
            }
          })
          .catch((error) => {
            console.log("[ERR] loadClinicData:", error);
          });
      }
    },
    ...mapMutations(["setClinic"]),
  },
  mounted() {
    document.title = 'Pacientes';
    this.loadClinicData();
    this.searchCustomers("");
  },
};
</script>

<style lang="scss" scoped>
.container {
  max-width: 1440px;
}

.customer-search-detail {
  border-top: 1px var(--theme-grey) solid;
  display: block;
}

.page-title {
  font-size: 32px;
  color: var(--theme-text-color);
  letter-spacing: 0.5px;
  line-height: 1.31;
  font-weight: 500;
  margin-bottom: 27px;
}

.customer-search-empty-message {
  color: var(--theme-grey);
  font-size: 24px;
  vertical-align: middle;
}

.customer-search-wrapper {
  margin-top: 30px;
  position: relative;
  overflow-y: scroll;
  width: 100%;
  height: 65vh;
}

.customer-search-results {
  width: 100%;

  th {
    font-size: 15px;
    letter-spacing: 0.3px;
    color: var(--theme-grey);
    border: none;
  }

  &__photo>img {
    width: 32px;
    height: 32px;
    border-radius: 16px;
    text-align: center;
    margin: auto 0;
    display: inline-block;
    background-color: var(--theme-grey);
    border: none;
  }

  &__row {
    cursor: pointer;
    background-color: transparent;
    transition: all 0.2s;
    border: none;
    border-bottom: 1px #e0e0e0 solid;

    &:hover {
      background-color: var(--theme-highlight);
    }

    td {
      font-size: 16px;
      line-height: 20px;
      color: var(--theme-text-color);
      vertical-align: baseline;
    }
  }
}
</style>
